import { addTicket } from "@/redux/rtk/features/CRM/ticket/ticketSlice";
import { loadAllTicketCategory } from "@/redux/rtk/features/CRM/ticketCategory/ticketCategorySlice";
import { loadAllCustomer } from "@/redux/rtk/features/customer/customerSlice";
import { loadAllPriority } from "@/redux/rtk/features/priority/prioritySlice";
import { InboxOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Upload, Mentions } from "antd";
import { loadAllStaff } from "@/redux/rtk/features/hrm/user/userSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// const customerId = localStorage.getItem("id");

const { Dragger } = Upload;
const { Option } = Select;
const { Option: MentionsOption } = Mentions;

const CreateTicket = ({ drawer, onClose, customerId: prefilledCustomerId }) => {
  const { t } = useTranslation();
  const { loading: cLoading, list: cList } = useSelector(
    (state) => state.ticketCategory
  );

  const { loading: pLoading, list: pList } = useSelector(
    (state) => state.priority
  );

  const { loading: customerLoading, list: customerList } = useSelector(
    (state) => state.customers
  );

  const { list: staffList, loading: staffLoading } = useSelector(
    (state) => state.users
  );

  const { loading: tLoading } = useSelector((state) => state.ticket);

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(loadAllTicketCategory());
    dispatch(loadAllPriority());
    dispatch(loadAllCustomer({ query: "all" }));
    dispatch(loadAllStaff({ query: "all" }));
  }, [dispatch]);

  useEffect(() => {
    if (prefilledCustomerId) {
      form.setFieldsValue({ customerId: prefilledCustomerId });
    }
  }, [prefilledCustomerId, form]);

  const onFinish = async (values) => {
    try {
      const formData = {
        contactId: prefilledCustomerId ? prefilledCustomerId : null,
        customerId: prefilledCustomerId ? null : values.customerId,
        email: values.email,
        subject: values.subject,
        description: values.description,
        ticketCategoryId: values.ticketCategoryId,
        priorityId: values.priorityId,
        files: values.files
          ? values.files.map((file) => file.originFileObj)
          : [],
      };

      // Submit the formData object to the server
      const resp = await dispatch(addTicket(formData));

      if (resp.payload.message === "success") {
        form.resetFields();
        if (onClose) onClose();
        navigate(`/admin/ticket/${resp.payload.data.id || resp.payload.data.ticketId}`);
      }
    } catch (error) {}
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div className={`${drawer ? "p-5" : "max-w-screen-md mx-auto p-5 mt-1"}`}>
        {!drawer && (
          <div className="text-center mb-8  ">
            <p className="mt-4 text-sm leading-7 text-gray-500 font-regular uppercase">
              {t("ticket.support")}
            </p>
            <h3 className="text-3xl sm:text-4xl leading-normal font-extrabold tracking-tight text-indigo-700">
              {t("ticket.createTicket")}
            </h3>
          </div>
        )}

        <Form
          name="ticketForm"
          className={`w-full ${drawer ? "" : "bg-gray-50 p-5 rounded-lg"}`}
          onFinish={onFinish}
          form={form}
          onFinishFailed={onFinishFailed}
          layout="vertical">
          <Form.Item
            name="email"
            label={t("ticket.emailAddress")}
            tooltip={t("ticket.emailTooltip")}>
            <Input placeholder={t("ticket.emailPlaceholder") || "youremail@something.com"} />
          </Form.Item>
          {/* Hide Customer Field as per user request */}
          <Form.Item
            name="customerId"
            label={t("ticket.customer")}
            className="hidden"
          >
            <Input type="hidden" />
          </Form.Item>

          {/* Hide Ticket Category Field as per user request */}
          <Form.Item name="ticketCategoryId" label={t("ticket.ticketCategory")} className="hidden">
            <Input type="hidden" />
          </Form.Item>

          {/* Hide Priority Field as per user request */}
          <Form.Item name="priorityId" label={t("ticket.priority")} className="hidden">
            <Input type="hidden" />
          </Form.Item>

          <Form.Item
            name="subject"
            label={t("ticket.subject")}
            rules={[
              {
                required: true,
                message: t("ticket.pleaseEnterSubject"),
              },
            ]}>
            <Input placeholder={t("ticket.subject")} />
          </Form.Item>

          <Form.Item name="description" label={t("common.description")}>
            <Mentions
              rows={4}
              placeholder={t("ticket.inTheTicket") || "Use @ to tag team members"}
              loading={staffLoading}
            >
              {staffList?.map((item) => (
                <MentionsOption key={item.id} value={item.username}>
                  {item.username}
                </MentionsOption>
              ))}
            </Mentions>
          </Form.Item>

          <Form.Item
            name="files"
            label={t("common.attachments")}
            className="hidden"
            valuePropName="fileList"
            getValueFromEvent={(e) => e && e.fileList}>
            <Dragger
              accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
              multiple={true}
              beforeUpload={() => false}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Drag and drop a files or click to select a files
              </p>
              <p className="ant-upload-hint">
                Supported files types: PNG, JPG, JPEG, PDF
              </p>
            </Dragger>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={tLoading}>
              {t("ticket.createTicket")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default CreateTicket;
